export const POSITIVE_SUBMIT_BUTTON = 0b1000
export const NEGATIVE_SUBMIT_BUTTON = 0b0100
export const CANCEL_BUTTON = 0b0010
